export const DEROGATION_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
} as const

export type DerogationStatus = (typeof DEROGATION_STATUS)[keyof typeof DEROGATION_STATUS]

export const DEROGATION_STATUS_LABELS: Record<DerogationStatus, string> = {
  [DEROGATION_STATUS.PENDING]: 'En attente',
  [DEROGATION_STATUS.APPROVED]: 'Approuvée',
  [DEROGATION_STATUS.REJECTED]: 'Rejetée',
}
